import Paper from '@mui/material/Paper'
import Stepper from '@mui/material/Stepper'
import { styled } from '@mui/material/styles'

type RegisterWorkspaceProps = {
  contentHeight: number
}

export const RegisterPageSurface = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  boxShadow: '0 22px 48px rgba(0, 0, 0, 0.2)',
}))

export const RegisterStepper = styled(Stepper)(() => ({
  overflowX: 'auto',
  height: 50,
}))

export const RegisterWorkspace = styled('div', {
  shouldForwardProp: (prop) => prop !== 'contentHeight',
})<RegisterWorkspaceProps>(({ contentHeight, theme }) => ({
  overflow: 'auto',
  marginTop: theme.spacing(2),
  height: contentHeight,
}))
